<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UxUYwd/tc-custom/9781621380191.jpg?1685327250867" alt="This image is the cover for the book Beauty in the Word"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beauty in the Word
      </h1>
      <p class="bookDescription body article font2">
        <p>What is a good education? What is it for? To answer these questions, Stratford Caldecott shines a fresh light on the three arts of language, in a marvelous recasting of the Trivium whereby Grammar, Dialectic, and Rhetoric are explored as Remembering, Thinking, and Communicating. These are the foundational steps every student must take towards conversion of heart and mind, so that a Catholic Faith can be lived out in unabashed pursuit of the True, the Good, and the Beautiful. Beauty in the Word is a unique contribution to bringing these bountiful aspects of the Real back to the center of learning, where they rightfully belong. If your concern is for the true meaning of education for your children, here is the place to begin.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stratford Caldecott, Anthony Esolen
      </h2>
      
      <p class="authorDescription body article">Stratford Caldecott is an editor of the English edition of Magnificat, and editor of Second Spring and Humanum. His books include The Seven Sacraments: Entering the Mysteries of God (Crossroad, 2006), Beauty for Truth's Sake: On the Re-enchantment of Education (Brazos, 2009), and Beauty in the Word: Rethinking the Foundations of Education (Angelico, 2012). He lives in Oxford.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Angelico Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8885f1ba